import { useEffect } from 'react'
import { Bridge } from 'src/utils/bridge'
import {
  useCustomMutation,
  versionCheckQueryOption,
} from 'src/hooks/react-query/useCustomMutation.hook'
import { VersionCheckSpace as vcspace } from 'src/types/api'
import { useChannel } from 'src/provider/ChannelContextProvider'
import { useGlobalStore } from 'src/store/zustand'
import { ERRCODE_SUCCESS } from 'src/service/constant/errcodes'
import { useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'

export function useAppInfo() {
  const { pathname } = useLocation()
  const { web } = useChannel()
  const { isCheckAppInfo, setIsCheckAppInfo } = useGlobalStore()

  const { mutateAsync: versionCheckMutate } = useCustomMutation<vcspace.Request, vcspace.Response>(
    versionCheckQueryOption(),
  )

  const checkAppInfo = (appVersion: string) => {
    Sentry.setTag('app_version', appVersion)
    versionCheckMutate({ Version: appVersion }).then(({ Header }) => {
      if (Header.ErrCode === ERRCODE_SUCCESS) {
        setIsCheckAppInfo(true)
      }
    })
  }

  const isMainPage = pathname === '/aos/main' || pathname === '/ios/main'

  useEffect(() => {
    if (web) {
      Sentry.setTag('app_version', 'web')
      return
    }

    if (!isCheckAppInfo && isMainPage) {
      Bridge.getAppInfo.req((appVersion) => checkAppInfo(appVersion))
      // //ios는 응답을 따로 받아야해서 여기서 처리
      Bridge.getAppInfo.res((appVersion) => checkAppInfo(appVersion))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
}
